import { clientbookApi } from '../core/clientbook-api';

export const getAiActivity = async ({ storeId }) => {
  return clientbookApi.get({
    url: '/ai/activity',
    query: { storeId },
  });
};

export const postAiActivityResult = async ({ aiActivityId, data }) => {
  return clientbookApi.post({
    url: `/ai/activities/${aiActivityId}/result`,
    data,
  });
};

export const postAiActivityMessage = async ({ aiActivityId, prompt }) => {
  return clientbookApi.post({
    url: `/ai/activities/${aiActivityId}/message`,
    data: { prompt },
  });
};
